import React, { useState } from 'react';
import ProgramCostModalContent from './ProgramCostModalContent';
import TrueImpactModal from 'shared/design-system/components/TrueImpactModal';
import { numberWithCommas } from 'shared/utils/numberUtils';
import { Cost } from './utils';

interface ProgramCostModalProps {
  open: boolean;
  title: string;
  defaultCostList: Cost[];
  reportId: number | string;
  handleClose: () => unknown;
  setCost: (cost: string) => unknown;
}

const ProgramCostModal: React.FC<ProgramCostModalProps> = ({
  reportId,
  open,
  title,
  defaultCostList,
  setCost,
  handleClose,
}) => {
  const [total, setTotal] = useState<number>(0);
  const handleCost = () => {
    handleClose();
    setCost(numberWithCommas(total.toFixed(2)));
  };
  return (
    <TrueImpactModal
      open={open}
      keepMounted={true}
      onClose={handleClose}
      title={title}
      next={{
        text: 'Add total to report',
        onClick: handleCost,
      }}
      previous={{
        text: 'Cancel',
        onClick: handleClose,
      }}
    >
      <ProgramCostModalContent
        reportId={reportId}
        total={total}
        defaultCostList={defaultCostList}
        handleTotal={setTotal}
      />
    </TrueImpactModal>
  );
};

export default ProgramCostModal;
